import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import { useEffect, useState } from "react";
import loadConfig from "../../../Services/Api/ApiServices";
import { GetItemType } from "../../../Redux/Reducers/Submitter/WPBItemType";
import {
  AddBudgetItems,
  GetBudgetItemsById,
  restValidateBudgetItems,
  UpdateBudgetItems,
  ValidateBudgetItems,
} from "../../../Redux/Reducers/ReportStage/BudgetItems";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import {
  GetBudgetItemsForStageById,
  UpdateBudgetItemsForStage,
  ValidationBudgetItemsForStage,
} from "../../../Redux/Reducers/ReportStage/BudgetItemsForStage";

const BudgetItemsForStageForm = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      BudgetItems: state.BudgetItems.BudgetItems,
      loadingBudgetItems: state.loadingBudgetItems?.loadingBudgetItems,
      ItemTypeReducers: state.ItemTypeReducers.ItemType,
      BudgetItemsValidate: state.BudgetItems.BudgetItemsValidate,
    };
  });
  console.log(state.ItemTypeReducers, "rrrr");

  const BudgetItemsList = useSelector(
    (state) => state.BudgetItemsForStage.BudgetItemsForStage
  );
  const ItemTypeList = useSelector((state) => state.ItemTypeReducers.ItemType);

  const [ItemTypeId, setItemTypeId] = useState(null);
  const [ItemName, setItemName] = useState(null);
  const [ItemDesecrabtion, setItemDesecrabtion] = useState(null);
  const [NumberOfunit, setNumberOfunit] = useState(null);
  const [UnitPrice, setUnitPrice] = useState(null);
  const [Total, setTotal] = useState(null);
  const [ActualSpend, setActualSpend] = useState(null);
  const [SupportingDocumentsAttachment, setSupportingDocumentsAttachment] =
    useState(null);
  const [NewAddedAttachment, setNewAddedAttachment] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();

  const [ActualSpendValidation, setActualSpendValidation] = useState(false);
  const [
    SupportingDocumentsAttachmentValidation,
    setSupportingDocumentsAttachmentValidation,
  ] = useState(false);

  // Function to calculate total automatically
  const calculateTotal = (units, price) => {
    const numberOfUnits = parseFloat(units || 0);
    const unitPrice = parseFloat(price || 0);
    const calculatedTotal = numberOfUnits * unitPrice;
    setTotal(calculatedTotal || 0);
  };

  // useEffect to recalculate total whenever NumberOfunit or UnitPrice changes
  useEffect(() => {
    calculateTotal(NumberOfunit, UnitPrice);
  }, [NumberOfunit, UnitPrice]);

  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  useEffect(() => {
    dispatch(GetItemType());
  }, []);

  const UpdateInfo = async () => {
    const result = await dispatch(
      ValidationBudgetItemsForStage({
        budgetItemsForStageId: props.budgetItemsForStageId,
        actualSpend: ActualSpend+"",
        supportingDocumentsAttachment:
          SupportingDocumentsAttachment?.name ||
          BudgetItemsList?.supportingDocumentsAttachment,
      })
    );
    console.log(result.payload, "ssssssdwwwwwwwwdwdwd");

    if (result.payload?.length > 0) {
      Swal.fire({
        title: "الرجاء  الحقول التالية",
        html: `
                    <div style="text-align: right; direction: rtl; font-size: 16px;">
                      <ul style="list-style-type: none; padding: 0;">${result?.payload
                        .map(
                          (msg) =>
                            `<li style="margin-bottom: 8px;">🔸 <strong>${msg}</strong></li>`
                        )
                        .join("")}</ul>`,
        icon: "warning",
        confirmButtonText: "حسناً",
      });
    }else{
 var formData = new FormData();
      formData.append("BudgetItemsForStageId", props.budgetItemsForStageId);
      formData.append("BudgetItemsId", BudgetItemsList?.budgetItemsId);
      formData.append("ReportStageId", BudgetItemsList?.reportStageId);
      formData.append("ActualSpend", ActualSpend);
      formData.append(
        "SupportingDocumentsAttachment",
        BudgetItemsList?.supportingDocumentsAttachment
      );
      formData.append("file", SupportingDocumentsAttachment);
      dispatch(UpdateBudgetItemsForStage(formData));
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }

    // let validationErrors = true;
    // if (ActualSpend == null || ActualSpend == "") {
    //   setActualSpendValidation(true);
    //   validationErrors = false;
    // }
    // if (
    //   SupportingDocumentsAttachment == null &&
    //   BudgetItemsList?.supportingDocumentsAttachment == null
    // ) {
    //   setSupportingDocumentsAttachmentValidation(true);
    //   validationErrors = false;
    // }
    // if (validationErrors) {
     
    // }
  };
  console.log(dataJsonObject, "fff");

  useEffect(() => {
    if (props.canEdit == "edit") {
      dispatch(
        GetBudgetItemsForStageById({
          budgetItemsForStageId: props.budgetItemsForStageId,
        })
      );
    }
  }, [props.budgetItemsId]);

  useEffect(() => {
    if (props.canEdit == "edit") {
      setActualSpend(BudgetItemsList?.actualSpend);
      setItemTypeId(BudgetItemsList?.itemTypeId);
      setItemName(BudgetItemsList?.itemName);
      setItemDesecrabtion(BudgetItemsList?.itemDescription);
      setNumberOfunit(BudgetItemsList?.numberOfUnits);
      setUnitPrice(BudgetItemsList?.unitPrice);
      setNewAddedAttachment(BudgetItemsList?.newAddedAttachment);
      setTotal(BudgetItemsList?.total);
    }
  }, [BudgetItemsList]);

  const HTML = (
    <>
      {" "}
      <div className="AddEdite">
        <AllDropDownsAHSF
          fieldsName="ItemType"
          show={true}
          disabled={true}
          arrayOoptionList={ItemTypeList}
          KeyText={"itemName"}
          KeyValue={"itemTypeId"}
          dropdownType={"normal"}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.itemTypeId : ""
          }
          onChange={(e) => {
            setItemTypeId(e.target.value);
          }}
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("ItemType")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="ItemName"
          show={true}
          disabled={true}
          onChange={(e) => {
            setItemName(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.itemName : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("ItemName")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <TextAreaAHSF
          fieldsName="ItemDescription"
          show={true}
          disabled={true}
          onChange={(e) => {
            setItemDesecrabtion(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.itemDescription : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("ItemDescription")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="NumberOfUnits"
          show={true}
          // type={"number"}
          comma={true}
          disabled={true}
          onChange={(e) => {
            setNumberOfunit(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.numberOfUnits : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("NumberOfUnits")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="UnitPrice"
          show={true}
          comma={true}
          disabled={true}
          onChange={(e) => {
            setUnitPrice(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.unitPrice : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("UnitPrice")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        
        <div style={{ marginTop: "10px" }}>
          <>
          
          </>
          {
            props.newAdded?<><label>
            مرفق التعديل الميزاني للبند
            <span className="star" style={{ color: "red" }}>
              *
            </span>
          </label></>:<></>
          }
          
          <div style={{ marginTop: "20px" }}>
            {
              props.newAdded?<>
             <AttachmentASFH
              id={"NewAddedAttachment"}
              title={"إضافة مرفق"}
              show={true}
              clear={false}
              AttachementType="NewAddedAttachment"
              singleFile={BudgetItemsList?.newAddedAttachment}
              disabled={true}
              readOnly={true}
              onChange={(e) => {
                setFileChange(fileChange + 1);
                setNewAddedAttachment(e.target.files[0]);
              }}
              showValidationMessage={
                state.BudgetItemsValidate
                  ? state.BudgetItemsValidate.includes("NewAddedAttachment")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            /> 
              </>:<></>
            }
            
            <InputAHSF
              fieldsName="Total"
              show={true}
              comma={true}
              // type={"number"}
              disabled={true}
              value={Total || 0} // Use value instead of defaultValue for controlled input
              showValidationMessage={false}
            />

            <InputAHSF
              fieldsName="ActualExchangeRate"
              show={true}
              comma={true}
              disabled={props.disabled}
              onChange={(e) => {
                setActualSpend(e.target.value);
              }}
              defaultValue={
                props.canEdit == "edit" ? BudgetItemsList?.actualSpend : ""
              }
              showValidationMessage={ActualSpendValidation}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <div style={{ marginTop: "20px" }}>
              <label>
                مرفق معززات الصرف
                <span className="star" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <div style={{ marginTop: "20px" }}>
                <AttachmentASFH
                  id={"SupportingDocumentsAttachment"}
                  title={" إضافة مرفق "}
                  show={true}
                  clear={false}
                  AttachementType="SupportingDocumentsAttachment"
                  singleFile={BudgetItemsList?.supportingDocumentsAttachment}
                  readOnly={props.disabled}
                  disabled={props.disabled}
                  onChange={(e) => {
                    setFileChange(fileChange + 1);
                    setSupportingDocumentsAttachment(e.target.files[0]);
                  }}
                  showValidationMessage={
                    SupportingDocumentsAttachmentValidation
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>
            </div>
          </div>
        </div>
        {!props.disabled ? (
          <>
            <div className="containersButton">
              <div>
                <ButtonAHSF
                  type={"submitter"}
                  onClick={() => {
                    UpdateInfo();
                  }}
                  disabled={false}
                  title={props.canEdit == "edit" ? "تعديل" : "إضافة"}
                  text={props.canEdit == "edit" ? "تعديل" : "إضافة"}
                  show={true}
                />
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  return (
    <div>
      {props.canEdit == "edit" ? (
        <>{BudgetItemsList?.budgetItemsId ? <>{HTML}</> : <></>}</>
      ) : (
        <>{HTML}</>
      )}
    </div>
  );
};

export default BudgetItemsForStageForm;
